import React from 'react'

interface IAccount {
    name: string
}

const Account = ({ name }: IAccount) => {
    return (
        <div>
            <h3>{name}</h3>
        </div>
    )
}

export default Account
